import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const index = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/index.vue");
const guideQa = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/guide-qa.vue");
const guideMaterial = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/guide-material.vue");
const guideNote = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/guide-note.vue");
const guideForm = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/guide-form.vue");
const kyd = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kyd.vue");
const yslb = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/yslb.vue");
const kzyzs = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kzyzs.vue");
const kyjd = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kyjd.vue");
const kcwyy = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kcwyy.vue");
const book = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/book.vue");
const policyDetail = () =>
  import(/* webpackChunkName: "guide" */ "./src/components/policy_detail.vue");
const vehicle = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/vehicle.vue");
const kzyd = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kzyd.vue");
const kwb = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kwb.vue");
const kktv = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kktv.vue");
const kcs = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kcs.vue");
const kmrd = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kmrd.vue");
const kyxt = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kyxt.vue");
const toggery = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/toggery.vue");
const generalMerchandise = () =>
  import(
    /* webpackChunkName: "guide" */ "./src/pages/jd/general-merchandise.vue"
  );
// 开健身房（含游泳池）
const gym = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/gym.vue");
// 补领婚姻登记证
const hydjz = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/blhydjz.vue");
// 人才公寓一件事
const rcgy = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/rcgy.vue");
// 区属共有产权保障住房满5年购买政府产权“一件事”
const bzzf = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/bzzf.vue");

const unionguide = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/unionguide.vue");
const smartguide = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/smartguide.vue");
const kyspzlg = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kyspzlg.vue");
const kbld = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kbld.vue");
const kmyypd = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kmyypd.vue");
const kdyy = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kdyy.vue");
const kjb = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kjb.vue");
const laborCapacity = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/labor-capacity.vue");
const jdcjsz = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/jdcjsz.vue");
const zjsb = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/zjsb.vue");
const zjsbHandle = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/zjsb-handle.vue");
const lnrjktj = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/lnrjktj.vue");
const industrialProjects = () =>
  import(
    /* webpackChunkName: "guide" */ "./src/components/industrial-projects/index.vue"
  );
const industrialProjectsifram = () =>
  import(
    /* webpackChunkName: "guide" */ "./src/components/industrial-projects/ifram.vue"
  );
const inIframe = () =>
  import(
    /* webpackChunkName: "guide" */ "./src/components/industrial-projects/inIframe.vue"
  );
const kgxd = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kgxd.vue");
const kgscs = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kgscs.vue");
const khgd = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/khgd.vue");
const kjlzm = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kjlzm.vue");
const klcssd = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/klcssd.vue");
const kqzcg = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kqzcg.vue");
// 开民宿
const kms = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/jd/kms.vue");
// 好办聚合页
const easydo = () =>
  import(/* webpackChunkName: "guide" */ "./src/pages/easydo/easydo.vue");

console.log(PROJECTNAME);
export default new Router({
  base: `/qykj/${PROJECTNAME}`,
  mode: "history",
  fallback: false,
  routes: [
    {
      path: "/guide",
      component: index,
      children: [
        {
          path: "qa",
          component: guideQa
        },
        {
          path: "material",
          component: guideMaterial
        },
        {
          path: "note",
          component: guideNote
        },
        {
          path: "form",
          component: guideForm
        }
      ]
    },
    {
      path: "/unionguide",
      component: unionguide
    },
    {
      path: "/zjsbHandle",
      component: zjsbHandle
    },
    {
      path: "/industrialProjects",
      component: industrialProjects
    },
    {
      path: "/industrialProjectsifram",
      component: industrialProjectsifram
    },
    {
      path: "/inIframe",
      component: inIframe
    },
    {
      path: "/smartguide",
      component: smartguide
    },
    {
      path: "/yslb",
      component: yslb
    },
    {
      path: "/policydetail",
      name: "policydetail",
      component: policyDetail
    },
    {
      name: "kyd",
      path: "/kyd",
      component: kyd
    },
    {
      name: "kcs",
      path: "/kcs",
      component: kcs
    },
    {
      name: "hydjz",
      path: "/hydjz",
      component: hydjz
    },
    {
      name: "kzyzs",
      path: "/kzyzs",
      component: kzyzs
    },
    {
      name: "kyjd",
      path: "/kyjd",
      component: kyjd
    },
    {
      name: "kcwyy",
      path: "/kcwyy",
      component: kcwyy
    },
    {
      name: "kwb",
      path: "/kwb",
      component: kwb
    },
    {
      name: "kktv",
      path: "/kktv",
      component: kktv
    },
    {
      name: "vehicle",
      path: "/vehicle",
      component: vehicle
    },
    {
      name: "book",
      path: "/book",
      component: book
    },
    {
      name: "kzyd",
      path: "/kzyd",
      component: kzyd
    },
    {
      name: "kmrd",
      path: "/kmrd",
      component: kmrd
    },
    {
      name: "kyxt",
      path: "/kyxt",
      component: kyxt
    },
    {
      name: "rcgy",
      path: "/rcgy",
      component: rcgy
    },
    {
      name: "bzzf",
      path: "/bzzf",
      component: bzzf
    },
    {
      name: "toggery",
      path: "/toggery",
      component: toggery
    },
    {
      name: "generalMerchandise",
      path: "/generalMerchandise",
      component: generalMerchandise
    },
    {
      name: "gym",
      path: "/gym",
      component: gym
    },
    {
      name: "kyspzlg",
      path: "/kyspzlg",
      component: kyspzlg
    },
    {
      name: "kbld",
      path: "/kbld",
      component: kbld
    },
    {
      name: "kmyypd",
      path: "/kmyypd",
      component: kmyypd
    },
    {
      name: "kdyy",
      path: "/kdyy",
      component: kdyy
    },
    {
      name: "kgxd",
      path: "/kgxd",
      component: kgxd
    },
    {
      name: "kgscs",
      path: "/kgscs",
      component: kgscs
    },
    {
      name: "khgd",
      path: "/khgd",
      component: khgd
    },
    {
      name: "kqzcg",
      path: "/kqzcg",
      component: kqzcg
    },
    {
      name: "klcssd",
      path: "/klcssd",
      component: klcssd
    },
    {
      name: "kjlzm",
      path: "/kjlzm",
      component: kjlzm
    },
    {
      name: "kjb",
      path: "/kjb",
      component: kjb
    },
    {
      name: "laborCapacity",
      path: "/laborCapacity",
      component: laborCapacity
    },
    {
      name: "jdcjsz",
      path: "/jdcjsz",
      component: jdcjsz
    },
    {
      name: "zjsb",
      path: "/zjsb",
      component: zjsb
    },
    {
      name: "lnrjktj",
      path: "/lnrjktj",
      component: lnrjktj
    },
    {
      name: "kms",
      path: "/kms",
      component: kms
    },
    {
      name: "easydo",
      path: "/easydo",
      component: easydo,
    },
  ]
});



// WEBPACK FOOTER //
// ./qp/router.js